import { SetupDashboardContext } from '@40seas/frontend/libs/contexts';
import { SetupDashboard } from '@40seas/frontend/libs/entities';
import { BrandConfigProvider, FeatureToggleProvider } from '@40seas/frontend/libs/providers';
import { BrowserRouter } from 'react-router-dom';
import { AdminRouter } from './components/admin/AdminRouter';
import { AppStoreContextProvider } from './providers/AppStoreContextProvider';
import { AuthenticationProvider } from './providers/AuthenticationProvider';

export const App = ({ setup }: { setup: SetupDashboard }) => {
    return (
        <FeatureToggleProvider setup={setup}>
            <BrandConfigProvider>
                <BrowserRouter>
                    <SetupDashboardContext.Provider value={setup}>
                        <AuthenticationProvider>
                            <AppStoreContextProvider>
                                <AdminRouter />
                            </AppStoreContextProvider>
                        </AuthenticationProvider>
                    </SetupDashboardContext.Provider>
                </BrowserRouter>
            </BrandConfigProvider>
        </FeatureToggleProvider>
    );
};
